import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=23db8e2a"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports